// polyfill remove
(function (arr) {
	arr.forEach(function (item) {
		if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				if (this.parentNode === null) {
					return;
				}
				this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// polyfill closest
(function() {
	if (!Element.prototype.matches) {
	  Element.prototype.matches = Element.prototype.msMatchesSelector ||
	                              Element.prototype.webkitMatchesSelector;
	}

	if (!Element.prototype.closest) {
	  Element.prototype.closest = function(s) {
	    var el = this;

	    do {
	      if (Element.prototype.matches.call(el, s)) return el;
	      el = el.parentElement || el.parentNode;
	    } while (el !== null && el.nodeType === 1);
	    return null;
	  };
	}
})();

// polyfill CustomEvent
(function () {

	if (typeof window.CustomEvent === 'function') return false;

	function CustomEvent (event, params) {
		params = params || { bubbles: false, cancelable: false, detail: null };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}

	window.CustomEvent = CustomEvent;
})();

// polyfill HTMLSelectElement.selectedOptions
(function() {
	'use strict';

	var select = HTMLSelectElement.prototype;
	if (Object.prototype.hasOwnProperty.call(select,'selectedOptions')) return;

	Object.defineProperty(select, 'selectedOptions', {
		get: function() {
			return this.querySelectorAll(':checked');
		},
		enumerable: true,
		configurable: true,
	});
})();